

























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import store from '../store'
import axios from 'axios'
import { getCustomers } from '../api/customers'
import singleCard from '@/components/dashboard/singleValue.vue'

@Component({
  name: 'Customers',
  components: { singleCard }
})
export default class extends Vue {
  created() {
    this.fetchUsers()
  }

  async myfunction() {
    const answer = await axios.get(process.env.VUE_APP_BASE_URL + 'api/')
    console.log(answer)
  }

  avatars = [
    '?accessoriesType=Blank&avatarStyle=Circle&clotheColor=PastelGreen&clotheType=ShirtScoopNeck&eyeType=Wink&eyebrowType=UnibrowNatural&facialHairColor=Black&facialHairType=MoustacheMagnum&hairColor=Platinum&mouthType=Concerned&skinColor=Tanned&topType=Turban',
    '?accessoriesType=Sunglasses&avatarStyle=Circle&clotheColor=Gray02&clotheType=ShirtScoopNeck&eyeType=EyeRoll&eyebrowType=RaisedExcited&facialHairColor=Red&facialHairType=BeardMagestic&hairColor=Red&hatColor=White&mouthType=Twinkle&skinColor=DarkBrown&topType=LongHairBun',
    '?accessoriesType=Prescription02&avatarStyle=Circle&clotheColor=Black&clotheType=ShirtVNeck&eyeType=Surprised&eyebrowType=Angry&facialHairColor=Blonde&facialHairType=Blank&hairColor=Blonde&hatColor=PastelOrange&mouthType=Smile&skinColor=Black&topType=LongHairNotTooLong',
    '?accessoriesType=Round&avatarStyle=Circle&clotheColor=PastelOrange&clotheType=Overall&eyeType=Close&eyebrowType=AngryNatural&facialHairColor=Blonde&facialHairType=Blank&graphicType=Pizza&hairColor=Black&hatColor=PastelBlue&mouthType=Serious&skinColor=Light&topType=LongHairBigHair',
    '?accessoriesType=Kurt&avatarStyle=Circle&clotheColor=Gray01&clotheType=BlazerShirt&eyeType=Surprised&eyebrowType=Default&facialHairColor=Red&facialHairType=Blank&graphicType=Selena&hairColor=Red&hatColor=Blue02&mouthType=Twinkle&skinColor=Pale&topType=LongHairCurly'
  ]

  pause = ms => new Promise(resolve => setTimeout(resolve, ms))

  active = []
  avatar = null
  open = []
  customers = []

  get items() {
    return [
      {
        name: 'Kunden',
        children: this.customers
      }
    ]
  }
  get selected() {
    if (!this.active.length) return undefined

    const id = this.active[0]

    return this.customers.find(customer => customer.id === id)
  }

  get customersWithOrders() {
    return this.customers.filter(customer => {
      return customer.info.email != null
    })
  }
  get customersWithoutOrders() {
    return this.customers.length - this.customersWithOrders.length
  }

  async fetchUsers() {
    const { data } = await getCustomers()
    console.log(data)
    if (data.successful) {
      console.log(data.customers)
      this.customers = data.customers
    }

    // return fetch('https://jsonplaceholder.typicode.com/users')
    //   .then(res => res.json())
    //   .then(json => item.children.push(...json))
    //   .catch(err => console.warn(err))
  }
  @Watch('selected')
  randomAvatar() {
    this.avatar = this.avatars[Math.floor(Math.random() * this.avatars.length)]
  }
}
